export default {
    'name': 'square-big',
    'width': '48',
    'height': '48',
    'viewBox': '0 0 48 48',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M28 20H20V28H28V20Z\' fill=\'#026958\'/>'
}
